import { useReveal } from "@/hooks/useReveal";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_private-collection-12/artifacts/carbet9i_IMG_2559.jpeg";

export default function HeroSection({ onRequestViewing, onDiscover }) {
  const r1 = useReveal();
  const r2 = useReveal();
  const r3 = useReveal();
  const r4 = useReveal();
  const r5 = useReveal();

  return (
    <section
      id="maison"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden grain"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="The Falcon Heart timepiece"
          className="absolute inset-0 w-full h-full object-cover pd-hero-bg"
          data-testid="hero-background-image"
        />
        <div className="absolute inset-0 vignette" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 min-h-screen flex flex-col justify-between pt-32 pb-16">
        <div ref={r1} className="pd-reveal text-center">
          <p className="eyebrow" style={{ textShadow: "0 1px 12px rgba(0,0,0,0.9)" }} data-testid="hero-eyebrow">
            Available by invitation only
          </p>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <div ref={r2} className="pd-reveal" style={{ transitionDelay: "120ms" }}>
            <p className="text-white/60 text-xs md:text-sm uppercase tracking-[0.5em] mb-6">
              The PiérrecDavís Maison Presents
            </p>
          </div>

          <h1
            ref={r3}
            className="pd-reveal font-serif-display text-white text-5xl sm:text-6xl md:text-7xl lg:text-[7.5rem] leading-[1.02] tracking-[0.08em]"
            style={{ transitionDelay: "260ms" }}
            data-testid="hero-headline"
          >
            THE FALCON HEART
          </h1>

          <div
            ref={r4}
            className="pd-reveal mt-8 max-w-2xl"
            style={{ transitionDelay: "420ms" }}
          >
            <p
              className="font-serif-body text-xl md:text-2xl text-white/85 italic tracking-wide"
              data-testid="hero-subheadline"
            >
              Mechanical Art for the Exceptional.
            </p>
            <div className="my-7 mx-auto hairline" />
            <p className="text-white/65 text-sm md:text-base leading-relaxed tracking-wide font-light max-w-xl mx-auto">
              A limited creation crafted for collectors who seek
              more than timekeeping.
            </p>
          </div>

          <div
            ref={r5}
            className="pd-reveal mt-12 flex flex-col sm:flex-row gap-5 items-center"
            style={{ transitionDelay: "620ms" }}
          >
            <button
              data-testid="hero-request-viewing-btn"
              onClick={onRequestViewing}
              className="btn-gold"
            >
              <span>Request Private Viewing</span>
            </button>
            <button
              data-testid="hero-discover-btn"
              onClick={onDiscover}
              className="btn-ghost"
            >
              Discover the Falcon Heart
            </button>
          </div>
        </div>

        <div className="flex items-end justify-between text-white/40 text-[0.65rem] uppercase tracking-[0.4em]">
          <span data-testid="hero-footer-left">Monaco · Geneva · Private</span>
          <span className="hidden md:inline">Maison No. 001</span>
          <span data-testid="hero-footer-right">Scroll ↓</span>
        </div>
      </div>
    </section>
  );
}
